import CategoriaView from "../views/CategoriaView.vue";
import ProductosView from "../views/ProductosView.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import ProveedoresView from "../views/ProveedoresView.vue";
import MarcaProductoView from "../views/MarcaProductoView.vue";
const routes = [
  {
    path: "/productos",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Productos",
        component: ProductosView,
        meta: {
          permissions: "baret_navbar:productos",
        },
      },
      {
        path: "categorias",
        name: "Categorías",
        component: CategoriaView,
        meta: {
          permissions: "baret_navbar:categorias",
        },
      },
      {
        path: "marcas",
        name: "Marcas",
        component: MarcaProductoView,
        meta: {
          permissions: "baret_navbar:marcasProductos",
        },
      },
      {
        path: "proveedores",
        name: "Proveedores",
        component: ProveedoresView,
        meta: {
          permissions: "baret_navbar:proveedores",
        },
      },
    ],
  },
];

export default routes;
